__turbopack_context__.v({
  "className": "cormorant_garamond_2cc56aee-module__MgDiXq__className",
});
